import script from "./esButtonIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./esButtonIcon.vue?vue&type=script&setup=true&lang=ts"

import "./esButtonIcon.vue?vue&type=style&index=0&id=86041508&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86041508"]])

export default __exports__